'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import {} from 'react';
import Loading from '../../components/loading/index.js';
import LoadingComponentContext from '../../contexts/loading-component.js';
import TranslateFunctionContext from '../../contexts/translate-function.js';
import useProvider from './provider.hook.js';
function I18nProvider({ children, fallbackLocale, LoadingComponent, locale, onLoadError, translations: translationsRecord, }) {
    const { translate } = useProvider({
        fallbackLocale,
        locale,
        onLoadError,
        translationsRecord,
    });
    return (_jsx(LoadingComponentContext.Provider, { value: LoadingComponent ?? Loading, children: _jsx(TranslateFunctionContext.Provider, { value: translate, children: children }) }));
}
export default I18nProvider;
//# sourceMappingURL=provider.view.js.map